/* ==========================================================================
   商品ページ下部の追従「カートに入れる」バー（ルミエール独自 / 2026-10-02 claude）
   見た目と全体の説明は snippets/lumiere-sticky-atc.liquid のコメント参照。

   【表示・非表示】（なごみ工房の下部バーと同じ動き）
     本来のカートボタンが画面の外（上でも下でも）にある間だけ表示する。
     ボタンが無い・押せない（売り切れ等）・非表示のときは出さない。

   【押したとき】
     本来のボタンをクリックするだけ。
     ★ GPOは本来のボタンを隠して、必須項目チェック付きの複製ボタン
       （.gpo-clone-atc-button）を作る。押す直前に毎回探し直し、複製があれば
       そちらを押す（読み込み直後に掴んだボタンを使い続けると、GPOが後から
       複製を作った場合に必須項目チェックを素通りしてしまうため）。
     ★ GPOの準備がまだ（オプション欄 .gpo-app がまだ無い）のに押されたら、
       カートに入れず、本来のボタンの位置までスクロールする。

   【価格・ボタン文字】
     ボタン文字（「予約注文」など）は本来のボタンから写し、変化に追従する。
     価格は「選択中バリエーションの本来の価格＋GPOの追加額」（currentPriceText 参照）。
   ========================================================================== */
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';

    var sectionId = bar.dataset.sectionId;
    var root = document.getElementById('MainProduct-' + sectionId) || document;
    var stickyBtn = bar.querySelector('[data-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var loadedAt = Date.now();

    /* 押すべき本来のボタン（GPOの複製を優先） */
    function getAtc() {
      return (
        root.querySelector('.product-form__submit.gpo-clone-atc-button') ||
        root.querySelector('.product-form__submit:not(.gpo-original-atc-button)')
      );
    }

    /* GPOのオプションがある商品で、GPOの準備がまだ終わっていないか */
    function gpoPending(atc) {
      if (!window.GPOConfigs) return false;
      if (atc && atc.classList.contains('gpo-clone-atc-button')) return false;
      var form = atc && atc.closest('form');
      if (form && form.querySelector('.gpo-app')) return false;
      return Date.now() - loadedAt < 10000;
    }

    /* ---------- 表示・非表示 ---------- */
    var shown = null;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('lumiere-sticky-atc--visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      stickyBtn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('lumiere-sticky-atc-on', on);
    }

    function checkVisibility() {
      var atc = getAtc();
      if (!atc || atc.disabled || !atc.offsetParent) {
        setShown(false);
        return;
      }
      var r = atc.getBoundingClientRect();
      setShown(r.bottom < 0 || r.top > window.innerHeight);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        checkVisibility();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* GPOが後から複製ボタンを作る・バリエーション変更で売り切れになる等に追従 */
    [500, 2000, 4000, 8000].forEach(function (ms) {
      setTimeout(checkVisibility, ms);
    });
    window.addEventListener('load', checkVisibility);

    /* ---------- 価格・ボタン文字を写す ---------- */
    function yen(text) {
      var m = String(text || '').replace(/[，,\s]/g, '').match(/[¥￥](\d+)/);
      return m ? parseInt(m[1], 10) : null;
    }

    /* 上部の価格（セール中はセール価格、通常時は通常価格） */
    function basePriceText() {
      var box = document.getElementById('price-' + sectionId);
      if (!box) return '';
      var el =
        box.querySelector('.price.price--on-sale .price__sale .price-item--last') ||
        box.querySelector('.price:not(.price--on-sale) .price__regular .price-item--regular');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    /* GPOで選んだオプションの追加額。
       GPOはオプション欄の下へ「選択すると¥19,000が価格に追加されます」と
       出すので（.gpo-total-text）、その金額を読む。表示が無い・見えない＝0円。 */
    function gpoAddon() {
      var t = root.querySelector('.gpo-total-text');
      if (!t || !t.offsetParent) return 0;
      return yen(t.textContent) || 0;
    }

    /* バリエーションごとの本来の価格（円）。snippets/lumiere-sticky-atc.liquid が出力 */
    var variantPrices = {};
    try {
      var json = bar.parentNode.querySelector('[data-sticky-variant-prices]');
      if (json) variantPrices = JSON.parse(json.textContent);
    } catch (e) {}

    /* いま選ばれているバリエーションの本来の価格（円）。分からなければ null */
    function variantPrice() {
      var atc = getAtc();
      var form = atc && atc.closest('form');
      var input = form && form.querySelector('[name="id"]');
      var p = input ? variantPrices[input.value] : undefined;
      return typeof p === 'number' ? p : null;
    }

    /* ★ 上部の価格表示は計算の元にしない。GPOが上部をオプション代込みに書き換える商品
         （1982 など）と書き換えない商品（2143 など）があり、上部＋追加額だと
         書き換える商品で二重に足してしまう（2026-10-04 修正）。
         上部の表示は、バリエーションの価格が取れなかったときの予備にだけ使う。 */
    function currentPriceText() {
      var addon = gpoAddon();
      var base = variantPrice();
      if (base === null) {
        if (addon) return '';            // 正しい合計が出せないときは価格を出さない
        return basePriceText();
      }
      return '¥' + (base + addon).toLocaleString('ja-JP');
    }

    function atcLabel(atc) {
      var span = atc && atc.querySelector('span');
      var text = (span || atc || {}).textContent || '';
      return text.replace(/\s+/g, ' ').trim();
    }

    function sync() {
      var price = currentPriceText();
      if (stickyPrice.textContent !== price) stickyPrice.textContent = price;
      var label = atcLabel(getAtc());
      if (label && stickyBtn.textContent !== label) stickyBtn.textContent = label;
      checkVisibility();
    }

    /* 上部の価格・ボタンは、バリエーション変更でテーマが作り直し、
       GPOが文字を書き換える。区画ごと見張って、変わったら写し直す */
    var syncQueued = false;
    var observer = new MutationObserver(function () {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(function () {
        syncQueued = false;
        sync();
      });
    });
    observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    sync();

    /* ---------- 押したとき ---------- */
    stickyBtn.addEventListener('click', function () {
      var atc = getAtc();
      if (!atc) return;
      if (gpoPending(atc)) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      atc.click();

      /* GPOの必須項目が未選択だと、GPOがカート追加を止めて項目に has-error を付ける。
         GPOのスクロールだけでは項目が上部の固定ヘッダーに隠れ「この項目は必須です」の
         文字しか見えないため（2026-10-02 位牌 2526 で確認）、最初のエラー項目を画面中央へ */
      setTimeout(function () {
        var errs = root.querySelectorAll('.gpo-element.has-error');
        for (var i = 0; i < errs.length; i++) {
          if (errs[i].offsetParent) {
            errs[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
      }, 400);
    });
  }

  function initAll() {
    document.querySelectorAll('.lumiere-sticky-atc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* テーマエディタでセクションを読み込み直したとき */
  document.addEventListener('shopify:section:load', initAll);
})();
